/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const CLEAR_ADDITIONAL_INFO = 'CLEAR_ADDITIONAL_INFO';

export function clearAdditionalInfo(payload) {
    return {type: CLEAR_ADDITIONAL_INFO, payload: payload};
}

export const INIT_UPLOAD = 'INIT_UPLOAD';

export function initUpload(payload) {
    return {type: INIT_UPLOAD, payload: payload};
}

export const RESOURCE_UPLOAD = 'RESOURCE_UPLOAD';

export function resourceUpload(payload) {
    return {type: RESOURCE_UPLOAD, payload: payload};
}

export const RESOURCE_UPLOAD_SUCCESS_DATA_EDIT = 'RESOURCE_UPLOAD_SUCCESS_DATA_EDIT';

export function resourceUploadSuccessDataEdit(payload) {
    return {type: RESOURCE_UPLOAD_SUCCESS_DATA_EDIT, payload: payload};
}

export const VALIDATE_ADDITIONAL_INFO = 'VALIDATE_ADDITIONAL_INFO';

export function validateAdditionalInfo(payload) {
    return {type: VALIDATE_ADDITIONAL_INFO, payload: payload};
}

export const GET_RESOURCE_SUCCESS = 'GET_RESOURCE_SUCCESS';

export  function getResourceSuccess(payload) {
    return {type: GET_RESOURCE_SUCCESS, payload: payload};
}

export const CLEAR_RESOURCE = 'CLEAR_RESOURCE';

export  function clearResource() {
    return {type: CLEAR_RESOURCE};
}


// WEBPACK FOOTER //
// ./src/_actions/resource.upload.actions.js